import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTo(0, 0);
      // For cases where there might be a scrollable container as well
      if (document.body) {
        document.body.scrollTo(0, 0);
      }
    };

    scrollToTop();
    
    // Sometimes React rendering or layout shifts happen slightly after navigation
    // Using a tiny timeout or requestAnimationFrame helps ensure we are at the top
    const timeoutId = setTimeout(scrollToTop, 10);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

